<template>
  <div class="card">
    <div class="card-header">
      <h4>Downloads</h4>
    </div>
    <div class="card-body">
      <b-tabs>
        <b-tab title="infrabau Downloads" active>
          <div clas="row">
            <div class="col-4">
              <div class="input-group" style="margin-top:20px;">
                <b-form-input style="border:1px solid lightgrey" v-model="tbl_filter.downloads" placeholder="Suchen"></b-form-input>
              </div>
            </div>
          </div>
          <div class="table-responsive datatable-vue" >
            <b-table
              show-empty
              :items="downloads"
              :filtered="onFilteredDownloads"
              :current-page="tbl_currentPage.downloads"
              :filter="tbl_filter.downloads"
              :per-page="tbl_perPage.downloads"
              :fields="tbl_fields.downloads"
            >
              <template slot="empty"><div class="text-center">Keine Downloads hinterlegt.</div></template>
              <template v-slot:cell(uploaded_by)="row">
                {{ row.item.download_id.owner.first_name }} {{ row.item.download_id.owner.last_name }}
              </template>
              <template v-slot:cell(created_on)="row">
                {{ transformDate(row.item.download_id.created_on) }}
              </template>
              <template v-slot:cell(actions)="row">
                <a :href="row.item.download_id.file.data.full_url" target="_blank">
                <feather
                  :id="'download_' + row.item.id"
                  type="download"
                  class="infra-blue pointer"
                  style="margin-right:5px;"                  
                ></feather>
                </a>
                <b-tooltip :target="'download_' + row.item.id" triggers="hover" placement="left">Download</b-tooltip>
              </template>
            </b-table>
            <div class="pagination-container" style="margin-top:10px;">
              <b-pagination
                v-model="tbl_currentPage.downloads"
                :total-rows="tbl_totalRows.downloads"
                :per-page="tbl_perPage.downloads"
                class="my-0"
              ></b-pagination>
            </div>
          </div>
        </b-tab>
        <b-tab title="Ihre Uploads">
          <div clas="row">
            <div class="col-4">
              <div class="input-group" style="margin-top:20px;">
                <b-form-input style="border:1px solid lightgrey" v-model="tbl_filter.uploads" placeholder="Suchen"></b-form-input>
              </div>
            </div>
          </div>
          <div class="table-responsive datatable-vue">
            <b-table
              show-empty
              :items="uploads"
              :filtered="onFilteredUploads"
              :current-page="tbl_currentPage.uploads"
              :filter="tbl_filter.uploads"
              :per-page="tbl_perPage.uploads"
              :fields="tbl_fields.uploads"
            >
              <template slot="empty"><div class="text-center">Keine Downloads hinterlegt.</div></template>
              <template v-slot:cell(uploaded_by)="row">
                {{row}}
                {{ row.item.owner.first_name }} {{ row.item.owner.last_name }}
              </template>
              <template v-slot:cell(created_on)="row">
                {{ transformDate(row.item.created_on) }}
              </template>
              <template v-slot:cell(actions)="row">
                <a :href="row.item.file.data.full_url" target="_blank">
                <feather :id="'download_' + row.item.id" type="download" class="infra-blue pointer" style="margin-right:5px;"></feather>
                </a>
                <b-tooltip :target="'download_' + row.item.id" triggers="hover" placement="left">Download</b-tooltip>
                <feather
                  :id="'remove_dd_' + row.item.id"
                  type="trash"
                  class="infra-blue pointer"
                  @click="removeDownloadAssignment(row.item)"
                ></feather>
                <b-tooltip :target="'remove_dd_' + row.item.id" placement="left">Datei löschen</b-tooltip>
              </template>
            </b-table>
            <div class="pagination-container" style="margin-top:10px;">
              <b-pagination
                v-model="tbl_currentPage.uploads"
                :total-rows="tbl_totalRows.uploads"
                :per-page="tbl_perPage.uploads"
                class="my-0"
              ></b-pagination>
            </div>
          </div>
          <div class="flex-row-end">
            <b-button class="btn btn-primary" @click="openUploadModal">Neue Datei</b-button>
          </div>
        </b-tab>
      </b-tabs>
    </div>
    <b-modal id="addNewKundeUpload" ok-only @hide="resetUploadModal">
      <div>
        <div><h6>Bild hinzufügen</h6></div>
        <div class="upload-dropzone" style="margin-bottom:10px;margin-top:10px;">
          <div class="red inline-block" v-if="hasError('upload_file')">Bitte wählen Sie ein Bild.</div>
          <dropzone
            ref="upload_dropzone"
            id="upload_kunde_dropzone"
            class="upload-kunde-dropzone"
            :options="dropzone.upload.options"
            v-on:vdropzone-success="processNewUpload"
            v-on:vdropzone-file-added="modal.upload.file = true"
            v-on:vdropzone-removed-file="modal.upload.file = false"
          ></dropzone>
        </div>
        <label>Name</label>&nbsp;
        <div class="red inline-block" v-if="hasError('upload_name')">- mindestens {{ validation.upload.name.minlength }} Zeichen.</div>
        <b-input-group prepend="Abc" class="form-input-group">
          <b-form-input v-model="modal.upload.name" v-bind:class="{ form_error: hasError('upload_name') }"></b-form-input>
        </b-input-group>
        <label>Beschreibung</label>&nbsp;
        <b-input-group prepend="Abc" class="form-input-group">
          <b-textarea v-model="modal.upload.beschreibung" rows="5"></b-textarea>
        </b-input-group>
        <label>Kategorie</label>
        <b-input-group class="form-input-group">
          <b-form-select
            v-model="modal.upload.kategorie"
            :options="modal.upload.options"
            name="category"
            v-bind:class="{ form_error: hasError('upload_kategorie') }"
          ></b-form-select>
        </b-input-group>
        <b-button class="btn btn-primary" style="width:100%;" @click="validateUpload">Hochladen</b-button>
      </div>
      <template slot="modal-header"><h4>Neue Datei hochladen</h4></template>
      <template slot="modal-ok">Schießen</template>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import vue2Dropzone from "vue2-dropzone";

export default {
  name: "KundeMedia",
  components: {
    dropzone: vue2Dropzone,
  },
  data() {
    return {
      validation_errors: [],
      tbl_fields: {
        downloads: [
          { key: "download_id.name", label: "Name", sortable: true },
          { key: "download_id.file.type", label: "Typ", sortable: true },
          { key: "download_id.category.name", label: "Kategorie", sortable: true },
          { key: "actions", label: "Aktionen", sortable: false },
        ],
        uploads: [
          { key: "name", label: "Name", sortable: true },
          { key: "file.type", label: "Typ", sortable: true },
          { key: "category.name", label: "Kategorie", sortable: true },
          { key: "actions", label: "Aktionen", sortable: false },
        ],
      },
      tbl_filter: {
        downloads: null,
        uploads: null,
      },
      tbl_currentPage: {
        downloads: 1,
        uploads: 1,
      },
      tbl_perPage: {
        downloads: 10,
        uploads: 10,
      },
      tbl_totalRows: {
        downloads: 1,
        uploads: 1,
      },
      dropzone: {
        upload: {
          options: null,
        },
      },
      modal: {
        upload: {
          name: "",
          beschreibung: "",
          file: false,
          options: [],
          kategorie: "default",
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      animations: "app/animations",
      toasts: "app/toasts",
      api: "auth/apiSettings",
      kou: "auth/kou",
      user: "auth/user",
      downloads: "media/downloads_kunde",
      uploads: "media/uploads_kunde",
      validation: "app/validation",
      categories: "media/categories",
      ready: "media/ready",
    }),
  },
  async created() {
    await this.init();
  },
  methods: {
    rstPagination() {
      this.tbl_totalRows = {
        downloads: this.downloads.length,
        uploads: this.uploads.length,
      };
    },
    async processNewUpload(upload, responseDirectus) {
      const createUploadPayload = {
        name: this.modal.upload.name,
        description: this.modal.upload.description,
        file: responseDirectus.data.id,
        category: this.modal.upload.kategorie,
        kunde: this.kou.id,
      };

      try {
        await this.$store.dispatch("media/newUpload", createUploadPayload);
        await this.$store.dispatch("media/getDownloadsOfKunde", this.kou.id);
        await this.$store.dispatch("media/getUploadsOfKunde", this.kou.id);
        this.rstPagination();
        this.closeUploadModal();
      } catch (error) {
        console.log(error);
        this.$toasted.show(error, this.toasts.failure);
      }
    },
    onFilteredDownloads(filteredItems) {
      this.tbl_totalRows.downloads = filteredItems.length;
      this.tbl_currentPage.downloads = 1;
    },
    onFilteredUploads(filteredItems) {
      this.tbl_totalRows.uploads = filteredItems.length;
      this.tbl_currentPage.uploads = 1;
    },
    async init() {
      //get the stuff
      if (!this.downloads.length) await this.$store.dispatch("media/getDownloadsOfKunde", this.kou.id);
      if (!this.uploads.length) await this.$store.dispatch("media/getUploadsOfKunde", this.kou.id);

      //init dropzone
      this.dropzone.upload.options = {
        url: this.api.customUploads,
        thumbnailMethod: "contain",
        thumbnailWidth: 200,
        maxFiles: 1,
        autoProcessQueue: false,
        init: function() {
          this.on("maxfilesexceeded", function(file) {
            this.removeAllFiles();
            this.addFile(file);
          });
        },
        dictDefaultMessage:
          '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-upload-cloud"><polyline points="16 16 12 12 8 16"></polyline><line x1="12" y1="12" x2="12" y2="21"></line><path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"></path><polyline points="16 16 12 12 8 16"></polyline></svg>',

        headers: {
          Authorization: "bearer " + JSON.parse(localStorage.getItem("directus-sdk-js")).token,
          "Cache-Control": null,
          "X-Requested-With": null,
        },
      };
      this.rstPagination();
    },
    async validateUpload() {
      this.validation_errors = [];
      const fields = ["name"];

      await Promise.all(
        fields.map(async (field) => {
          const result = await this.$store.dispatch("app/validateField", {
            context: "upload",
            field,
            value: this.modal.upload[field],
          });

          if (!result) this.validation_errors.push("upload_" + field);
        })
      );

      if (this.modal.upload.kategorie == "default") this.validation_errors.push("upload_kategorie");
      if (!this.modal.upload.file) this.validation_errors.push("upload_file");

      if (this.validation_errors.length) return;

      await this.startUpload();
    },
    async startUpload() {
      this.$refs.upload_dropzone.processQueue();
    },
    hasError(field) {
      return this.validation_errors.indexOf(field) > -1 ? true : false;
    },
    async openUploadModal() {
      try {
        await this.getCategories();
        this.rstPagination();
      } catch (error) {
        console.log(error);
        this.$toasted.show(error, this.toasts.failure);
      }
      this.$bvModal.show("addNewKundeUpload");
    },
    closeUploadModal() {
      this.$bvModal.hide("addNewKundeUpload");
    },
    resetUploadModal() {
      this.validation_errors = [];
      this.modal.upload = {
        name: "",
        beschreibung: "",
        file: false,
        options: [],
        kategorie: "default",
      };
    },
    async getCategories() {
      try {
        await this.$store.dispatch("media/getCategories");
        this.getCatOptions();
      } catch (error) {
        console.log(error);
        this.$toasted.show(error, this.toasts.failure);
      }
    },
    getCatOptions() {
      let categories = this.categories.map((c) => {
        return { value: c.id, text: c.name };
      });
      categories.unshift({ value: "default", text: "Bitte wählen", disabled: true });
      this.modal.upload.options = categories;
    },
    downloadFile(file) {
      console.log("Download File was called");
      console.log(file);
    },
    async removeDownloadAssignment(download) {
      console.log("removeDownloadAssignment was called");
      console.log(download);
      try {
        await this.$store.dispatch("media/deleteUpload", download.id);
        await this.$store.dispatch("media/getUploadsOfKunde", this.kou.id);
      } catch (error) {
        console.log(error);
        this.$toasted.show(error, this.toasts.failure);
      }
    },

  },
};
</script>

<style></style>
